import { render, staticRenderFns } from "./SettingGeneral.vue?vue&type=template&id=d02d946a"
import script from "./SettingGeneral.vue?vue&type=script&lang=js"
export * from "./SettingGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports